<template>
  <div class="row">
    <div class="col-12">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <div>
            <router-link v-if="isCurrentUserCoordinator"
                         :to="userId ? { name: 'userBasicInfo', params: { id: userId } } : { name: 'userBasicInfo' }"
                         :class="{ active: $route.name === 'userBasicInfo' }"
                         class="nav-item nav-link"
                         role="tab"
                         aria-controls="nav-home"
                         aria-selected="true">
              Informationen für Mitarbeiter
            </router-link>

            <router-link v-else
                         :to="userId ? { name: 'userForm', params: { id: userId } } : { name: 'userForm' }"
                         :class="{ active: $route.name === 'userForm' }"
                         class="nav-item nav-link"
                         role="tab"
                         aria-controls="nav-home"
                         aria-selected="true">
              Informationen für Mitarbeiter
            </router-link>
          </div>

          <router-link
              v-if="userId"
              :to="{ name: 'userQualificationList' }"
              :class="{ active: $route.name === 'userQualificationList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Qualifikationen
          </router-link>

          <router-link
              v-if="userId"
              :to="{ name: 'furtherEducationList' }"
              :class="{ active: $route.name === 'furtherEducationList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Weiterbildungen
          </router-link>

          <router-link
              v-if="userId && employeeType === 'student'"
              :to="{ name: 'studentWorkingDaysList' }"
              :class="{ active: $route.name === 'studentWorkingDaysList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Arbeitstage Student/Schüler
          </router-link>
        </div>

      </nav>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, toRefs} from 'vue';
import {piniaUserStore} from "@/store/piniaUserStore";

const piniaUserState = piniaUserStore();
const isCurrentUserCoordinator = computed(() => piniaUserState.currentUser.isCoordinator);

const props = defineProps({
  userId: {
    type: [String, Number],
    required: false,
    default: null,
  },
  employeeType: {
    type: String,
    required: false
  }
});

const {userId, employeeType} = toRefs(props);
</script>

<style scoped>
</style>